import React from "react";
import hm from "../images/home.png"
import tm from "../images/team.png"
import dt from "../images/details.png"
import wt from "../images/wallet.png"
import sup from "../images/support.png"
import { Link } from "react-router-dom";
export default function Footer() {
  return (
    <>
      <nav
        className="navbar navbar-expand bg-secondary navbar-dark sticky-bottom justify-content-between"
        style={{ position: "fixed", bottom: 0, width: "100%", padding:"0px" }}>

        <div className="d-flex justify-content-between w-100 me-auto ms-auto" >
          <div className="nav-item ">
            <Link to="/" className="nav-link nav-footer">
              <img
                className="rounded-circle me-lg-2"
                src={hm}
                alt ="Home"
                style={{ width: 35, height: 35 }}
                
              />
              <br/>
              <span className="text-menu text-info">Home</span>
            </Link>
          </div>
          <div className="nav-item ">
            <Link to="/" className="nav-link nav-footer">
              <img
                className="rounded-circle me-lg-2"
                src={tm}
                alt="Home"
                style={{ width: 35, height: 35 }}
              />
              <br/>
              <span className="text-menu text-info">Team</span>
            </Link>
          </div>
          <div className="nav-item ">
            <Link to="#" className="nav-link nav-footer">
              <img
                className="rounded-circle me-lg-2"
                src={dt}
                alt = "Home"
                style={{ width: 35, height: 35 }}
              />
              <br/>
              <span className="text-menu text-info">Detail</span>
            </Link>
          </div>
          <div className="nav-item ">
            <Link to="/" className="nav-link nav-footer">
              <img
                className="rounded-circle me-lg-2"
                src={wt}
                alt = "Home"
                style={{ width: 35, height: 35 }}
              />
              <br/>
              <span className="text-menu text-info">Wallet</span>
            </Link>
          </div>
          <div className="nav-item " >
            <Link to="/" className="nav-link nav-footer">
              <img
                className="rounded-circle me-lg-2"
                src={sup}
                alt = "Home"
                style={{ width: 35, height: 35 }}
              />
              <br/>
              <span className="text-menu text-info">Support</span>
            </Link>
          </div>
        </div>
      </nav>
    </>
  );
}
